export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["对手信息"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / 账户 / 电子邮件 / 电话"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / 加密地址 / 电子邮件 / 电话"])}
}